import { RepeatableDataMap } from '@/store/modules/repeatable/types';

export interface RepeatableState {
  data: RepeatableDataMap;
}

export const state = (): RepeatableState => {
  return {
    data: {}
  };
};
